import supabase from "@/lib/supabase";

/**
 * "Continue with Microsoft" button. Uses Supabase's `azure` OAuth provider
 * (Microsoft renamed AAD → Entra ID; the Supabase provider key is still `azure`).
 *
 * Setup once, on your side:
 *   1. Supabase Dashboard → Authentication → Providers → **Azure (Microsoft)** → Enable
 *   2. In the Azure Portal, register a new app under Entra ID → App registrations
 *   3. Redirect URI: https://xumntfnrljwcuwtocbjk.supabase.co/auth/v1/callback
 *   4. Copy Application (client) ID and a client secret → paste into Supabase
 *   5. Supported account types: "Any Microsoft Entra tenant + personal Microsoft accounts"
 *      so both institutional and personal @outlook.com / @hotmail.com users work.
 */
export default function MicrosoftSignInButton({ next, label = "Continue with Microsoft" }) {
  const handleClick = async () => {
    const redirectTo = `${window.location.origin}/auth/callback${next ? `?next=${encodeURIComponent(next)}` : ""}`;
    await supabase.auth.signInWithOAuth({
      provider: "azure",
      options: {
        redirectTo,
        // Ask for the standard OpenID scopes so we get email + name back.
        scopes: "email openid profile",
      },
    });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid="microsoft-signin-button"
      className="w-full flex items-center justify-center gap-3 border border-[var(--line)] bg-white hover:bg-[var(--cream)] transition-colors py-2.5 px-4 rounded text-sm font-medium text-[var(--navy)]"
    >
      <svg width="18" height="18" viewBox="0 0 23 23" aria-hidden="true">
        <path fill="#f25022" d="M1 1h10v10H1z"/>
        <path fill="#00a4ef" d="M1 12h10v10H1z"/>
        <path fill="#7fba00" d="M12 1h10v10H12z"/>
        <path fill="#ffb900" d="M12 12h10v10H12z"/>
      </svg>
      <span>{label}</span>
    </button>
  );
}
